import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Icon,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  useToast,
} from 'me-component-library';
import { useTranslation } from '../../hooks';
import { useState } from 'react';
import { useDisableUserOtp } from '../../hooks/useDisableUserOtp';

export interface DeleteUserModalProps {
  userId: string;
  email: string;
  projectId: string;
}

export const Reset2FAModal = ({
  userId,
  projectId,
  email,
}: DeleteUserModalProps) => {
  const t = useTranslation();
  const { mutate, isLoading, isError } = useDisableUserOtp(projectId);
  const { toast } = useToast();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);

  const openDeleteModal = () => {
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleUserDelete = () => {
    mutate(
      {
        projectId,
        userId,
      },
      {
        onSuccess: () => {
          closeDeleteModal();
          toast({
            title: t('projectDetail.userList.reset2FA.toast.success.title'),
            description: t(
              'projectDetail.userList.reset2FA.toast.success.description',
              {
                email: email,
              },
            ),
          });
        },
      },
    );
  };

  return (
    <Dialog open={isDeleteModalOpen}>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger>
            <DialogTrigger onClick={openDeleteModal} asChild>
              <div>
                <Icon
                  name="keySquare"
                  className="select-none cursor-pointer text-yellow-500"
                />
              </div>
            </DialogTrigger>
          </TooltipTrigger>
          <TooltipContent>
            {t('projectDetail.userList.actions.reset2FA')}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <DialogContent onCloseClick={closeDeleteModal}>
        <DialogHeader>
          <DialogTitle>
            {t('projectDetail.userList.reset2FA.title')}
          </DialogTitle>
          <DialogDescription>
            <span>
              {t('projectDetail.userList.reset2FA.subtitle.part1')}
              <span className="font-bold">
                {t('projectDetail.userList.reset2FA.subtitle.part2', {
                  email: email,
                })}
              </span>
              {t('projectDetail.userList.reset2FA.subtitle.part3')}
            </span>
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-between">
          <Button
            variant="destructive"
            data-testid="confirm-delete-user-button"
            isLoading={isLoading}
            onClick={() => handleUserDelete()}
          >
            {t('projectDetail.userList.reset2FA.button')}
          </Button>
          <Button onClick={closeDeleteModal}>
            {t('projectDetail.userList.reset2FA.cancel')}
          </Button>
        </div>
        {isError && (
          <span className="text-red-500">
            {t('projectDetail.userList.reset2FA.error')}
          </span>
        )}
      </DialogContent>
    </Dialog>
  );
};
